import Provenienze from "./Provenienze";
export default Provenienze;